// Base encoders / decoders just base encode / decode between binary and
// textual representation. They are unaware of multibase.
export {};
//# sourceMappingURL=interface.js.map